import Vue from 'vue'
import VueRouter from 'vue-router'
import Routes from '@/router'
import { routerBeforeEach } from '@/router/middleware'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: Routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
router.beforeEach(routerBeforeEach)

export default router
